import { Markdown } from '@ibsys/kit';
import { format } from 'date-fns';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { AiAgentMessage } from '@/entities/ai-agent-chat';
import { ChatMessage, ChatMessageCloud, ChatMessageContent, ChatMessageTime, ChatMessageTitle } from '@/shared/ui/Chat';

type Props = {
  message: AiAgentMessage;
  isLast: boolean;
};

export const MessageBubble: FC<Props> = ({ message, isLast }) => {
  const { t } = useTranslation(['aiAgent']);
  const isUser = message.role === 'USER';

  return (
    <ChatMessage side={isUser ? 'right' : 'left'} isLast={isLast}>
      <ChatMessageCloud>
        {!isUser && <ChatMessageTitle>{t('aiAgent:title')}</ChatMessageTitle>}
        <ChatMessageContent>
          <Markdown className={'w-full'}>{message.content}</Markdown>
        </ChatMessageContent>
        <ChatMessageTime>{format(new Date(message.createdAt), 'HH:mm')}</ChatMessageTime>
      </ChatMessageCloud>
    </ChatMessage>
  );
};
